const getBrandFromLocation = () => {
  const location = window.location.hostname;
  return location.split("-")[0];
};

const getSubdomainFromLocation = () => {
  const location = window.location.hostname;
  return location.split(".").slice(1).join(".");
};

const getAccessBrand = () => {
  const brand = getBrandFromLocation();
  const subdomain = getSubdomainFromLocation();

  const brandUrls = {
    "crmmobileadmindev.dosetech.co":
      "https://api-crm-admin-dev.dosetech.co/api",
  };

  if (process.env.NODE_ENV === "development" || brandUrls[brand]) {
    return {
      baseURL: "https://api-crm-admin-dev.dosetech.co/api",
      reportURL: "https://api-crm-report-dev.dosetech.co/api",
    };
  }

  return {
    baseURL: `${window.location.protocol}//api-${brand}-admin-${process.env.VUE_APP_MODE}.${subdomain}/api`,
    reportURL: `${window.location.protocol}//api-${brand}-report-${process.env.VUE_APP_MODE}.${subdomain}/api`,
  };
};

export { getAccessBrand };
